export default {
    namespaced: true,

    state: {
        tablePreferences: {}
    },

    mutations: {
        SET_TABLE_PREFERENCES(state, { key, columns }) {
            state.tablePreferences = {
                ...state.tablePreferences,
                [key]: columns
            };
        }
    },

    actions: {
        saveTablePreferences({ commit }, { key, columns }) {
            commit('SET_TABLE_PREFERENCES', { key, columns });
        }
    },

    getters: {
        getTablePreferences: (state) => (key) => {
            return state.tablePreferences[key] || null;
        }
    }
}; 